import React, { useEffect, createContext, useState, ReactNode, useContext } from 'react';
import ReactPaginate from 'react-paginate';
// API URL BASE
export const URL_API = 'https://api.etsdetf.com/api'
// export const URL_API = 'https://apitest.etsdetf.com/api'
// export const URL_API = 'http://localhost:8000/api'
// export const Token = JSON.parse(localStorage.getItem("login")!);

export const formatDate = (date?: Date): string => {
    if (!date) {
        return ''; // Retourne une chaîne vide si la date est undefined
    }
    return new Date(date).toLocaleDateString('gn-GN', {
        day: "numeric",
        month: "long",
        year: "numeric"
    });
};

export const convertirEnNombre = (valeur: string): number => {
    const montantNettoye = valeur.replace(/\s+/g, '');
    return parseInt(montantNettoye);
};

export const calculateDaysRemaining = (targetDateStr: string) => {
    const targetDate = new Date(targetDateStr); // Convertir la chaîne en objet Date
    const today = new Date(); // Date actuelle

    // Calculer la différence en millisecondes, puis convertir en jours
    const diffTime = targetDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24)); // Convertir en jours
    return diffDays;
};

export const getWeekOfMonth = (date?: Date | string): number => {
    if (!date) {
        return 0;
    }

    if (typeof date === 'string') {
        date = new Date(date);
    }
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        throw new Error('Invalid date');
    }

    const tempDate = new Date(date);
    tempDate.setDate(1);

    let firstDayOfMonth = tempDate.getDay(); // 0 = dimanche
    if (firstDayOfMonth === 0) {
        firstDayOfMonth = 7; // Commencer la semaine lundi
    }

    const dayOfMonth = date.getDate();
    return Math.ceil((dayOfMonth + firstDayOfMonth - 1) / 7);
};

export function formatPrice(amount?: number) {
    if (!amount) {
        return '0 GNF';
    }
    const formatter = new Intl.NumberFormat('gn-GN', {
        style: 'currency',
        currency: 'GNF',
        minimumFractionDigits: 0, // Pas de décimales pour le Franc guinéen
        maximumFractionDigits: 0,
    });

    return formatter.format(amount);
}

export const formatPhoneNumber = (phoneNumber: string | undefined): string => {
    if (!phoneNumber) {
        return 'Undefined';
    }
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length === 9) {
        return `+224 ${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
    }
    return phoneNumber;
};

export const truncateText = (text: string, maxLength: number): string => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

// src/utils/numberToWords.ts
export const numberToWords = (num: number): string => {
    const units = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
    const teens = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"];
    const tens = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix"];
    const thousands = ["", "mille", "million"];

    if (num === 0) return "zéro";
    if (num < 0) return "moins " + numberToWords(-num);

    let words = "";

    const getHundreds = (n: number): string => {
        let str = "";
        if (n > 99) {
            str += units[Math.floor(n / 100)] + " cent";
            if (n % 100 > 0) str += " ";
        }
        const remainder = n % 100;
        if (remainder < 10) str += units[remainder];
        else if (remainder < 20) str += teens[remainder - 10];
        else {
            str += tens[Math.floor(remainder / 10)];
            if (remainder % 10 > 0) str += "-" + units[remainder % 10];
        }
        return str;
    };

    if (num < 1000) return getHundreds(num);

    let thousandMultiplier = 0;
    while (num > 0) {
        const chunk = num % 1000;
        if (chunk) {
            words = (chunk === 1 && thousandMultiplier === 1 ? "" : getHundreds(chunk)) + " " + thousands[thousandMultiplier] + " " + words;
        }
        num = Math.floor(num / 1000);
        thousandMultiplier++;
    }

    return words.trim();
};

export const generateRandomNumber = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const supprimerBalises = (chaine: string): string => {
    // Expression régulière pour supprimer toutes les balises HTML et CSS
    const reg = /<\/?[^>]+(>|$)/gm;
    return chaine.replace(reg, '');
}

export const hasPermission = (requiredPermissions?: string[]): boolean => {
    if (!requiredPermissions) return true;
    const userPermissions = JSON.parse(localStorage.getItem("permissions")!)
    return requiredPermissions.some((permission) =>
        userPermissions.includes(permission)
    );
};

export const itemHasPermission = (permission?: string): boolean => {
    if (!permission) return true;
    const userPermissions: string[] = JSON.parse(localStorage.getItem("permissions") || "[]");
    return userPermissions.includes(permission);
};


export const formatMontant = (valeur: string) => {
    // Supprime tout sauf les chiffres
    const montantNettoye = valeur.replace(/[^\d]/g, '');

    // Formate le montant avec des espaces tous les trois chiffres
    return montantNettoye.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};


const units: { [key: number]: string } = {
    0: 'zéro', 1: 'un', 2: 'deux', 3: 'trois', 4: 'quatre',
    5: 'cinq', 6: 'six', 7: 'sept', 8: 'huit', 9: 'neuf'
  };
  
  const tens: { [key: number]: string } = {
    10: 'dix', 11: 'onze', 12: 'douze', 13: 'treize',
    14: 'quatorze', 15: 'quinze', 16: 'seize',
    20: 'vingt', 30: 'trente', 40: 'quarante',
    50: 'cinquante', 60: 'soixante', 70: 'soixante-dix',
    80: 'quatre-vingt', 90: 'quatre-vingt-dix'
  };
  
  const bigNumbers: { [key: string]: string } = {
    1_000: 'mille',
    1_000_000: 'million',
    1_000_000_000: 'milliard',
  };
  
  const convertNumberToWords = (value: number): string => {
    if (value === 0) return 'zéro';
  
    if (value < 20) return tens[value] || units[value];
  
    if (value < 100) {
      const tenPart = Math.floor(value / 10) * 10;
      const unitPart = value % 10;
      return `${tens[tenPart]}${unitPart !== 0 ? '-' + units[unitPart] : ''}`;
    }
  
    if (value < 1000) {
      const hundredPart = Math.floor(value / 100);
      const rest = value % 100;
      return `${hundredPart > 1 ? units[hundredPart] + ' cent' : 'cent'} ${rest ? convertNumberToWords(rest) : ''}`.trim();
    }
  
    for (const [key, label] of Object.entries(bigNumbers).reverse()) {
      const divisor = Number(key);
      if (value >= divisor) {
        const bigPart = Math.floor(value / divisor);
        const rest = value % divisor;
        return `${convertNumberToWords(bigPart)} ${label}${bigPart > 1 ? 's' : ''} ${rest ? convertNumberToWords(rest) : ''}`.trim();
      }
    }
  
    return '';
  };
  
 export const convertAmountToWordsGNF = (amount: number): string => {
    const francs = Math.floor(amount);
    const francPart = francs > 0 ? `${convertNumberToWords(francs)} franc${francs > 1 ? 's guinéens' : ' guinéen'}` : '';
    return francPart || 'zéro franc guinéen';
};
  


type Item = { [key: string]: any }

interface PaginationProps {
    items: Item[];
    itemsPerPage: number;
}

export const PaginationComponent: React.FC<PaginationProps> = ({ items, itemsPerPage }) => {
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [currentItems, setCurrentItems] = useState<Item[]>([]);

    const pageCount = Math.ceil(items.length / itemsPerPage);

    useEffect(() => {
        const endOffset = (currentPage + 1) * itemsPerPage;
        setCurrentItems(items.slice(currentPage * itemsPerPage, endOffset));
    }, [currentPage, items, itemsPerPage]);

    const handlePageClick = (event: { selected: number }) => {
        setCurrentPage(event.selected);
    };

    return (
        <div>
            <ul>
                {currentItems.map(item => (
                    <li key={item.id}>{item.name}</li>
                ))}
            </ul>
            <ReactPaginate
                nextLabel="Suivant >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={pageCount}
                previousLabel="< Précédent"
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
};

type PaginateProps = {
    totalPages: number;
    paginate: (pageNumber: number) => void;
    currentPage: number;
};

export const Pagination: React.FC<PaginateProps> = ({ totalPages, paginate, currentPage }) => {
    const pageNumbers: number[] = [];
    const maxVisiblePages = 5;

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = () => {
        const pages: JSX.Element[] = [];

        if (currentPage > 3) {
            pages.push(
                <li key={1} className={`${Number(currentPage) === 1 ? 'active' : ''}`}>
                    <button type={'button'} onClick={() => paginate(1)}>1</button>
                </li>
            );
            if (currentPage > 4) {
                pages.push(<li key="dots-start">...</li>);
            }
        }

        for (let i = Math.max(1, currentPage - 2); i <= Math.min(currentPage + 2, totalPages); i++) {
            pages.push(
                <li key={i} className={`${currentPage === i ? 'active' : ''}`}>
                    <button onClick={() => paginate(i)}>{i}</button>
                </li>
            );
        }

        if (currentPage < totalPages - 2) {
            if (currentPage < totalPages - 3) {
                pages.push(<li key="dots-end">...</li>);
            }
            pages.push(
                <li key={totalPages} className={`${currentPage === totalPages ? 'active' : ''}`}>
                    <button onClick={() => paginate(totalPages)}>{totalPages}</button>
                </li>
            );
        }

        return pages;
    };

    return (
        <div className="pagination-wrapper pagination-wrapper-left">
            <ul className="pg-pagination">
                {currentPage === 1 ? (
                    <li>
                        <button aria-label="Previous" disabled>
                            <i className="fi ti-angle-left"></i>
                        </button>
                    </li>
                ) : (
                    <li>
                        <button onClick={() => paginate(currentPage - 1)} aria-label="Previous">
                            <i className="fi ti-angle-left"></i>
                        </button>
                    </li>
                )}

                {renderPageNumbers()}

                {currentPage === totalPages ? (
                    <li>
                        <button aria-label="Next" disabled>
                            <i className="fi ti-angle-right"></i>
                        </button>
                    </li>
                ) : (
                    <li>
                        <button onClick={() => paginate(currentPage + 1)} aria-label="Next">
                            <i className="fi ti-angle-right"></i>
                        </button>
                    </li>
                )}
            </ul>
        </div>
    );
};


